import { createSlice } from '@reduxjs/toolkit'
import { type ITermListResponse, type ITerm } from '../../../models/Term'
import { getTermByIdApi } from './api'

export interface TermsSliceType {
  term: ITerm | null
  termLoading: boolean
}

export const initialState: TermsSliceType = {
  term: null,
  termLoading: false
}

const TermsSlice = createSlice({
  name: 'terms',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    // Get single terms Details
      .addCase(getTermByIdApi.pending, (state) => {
        state.termLoading = true
      })
      .addCase(getTermByIdApi.fulfilled, (state, action) => {
        state.term = action.payload
        state.termLoading = false
      })
      .addCase(getTermByIdApi.rejected, (state) => {
        state.termLoading = false
      })
  }
})

export default TermsSlice.reducer
